import type { CommonSVGProps } from './helpers';

export const IconHandwrittenChevronRight = (props: Pick<CommonSVGProps, 'height' | 'width'>) => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <g>
      <path
        d="M7.69833 4C8.50669 5.16115 9.26785 6.28533 10.2095 7.3251C10.4521 7.59293 11.206 8.1573 11.3272 8.59259C11.5291 9.31754 6.65973 11.6509 6 12"
        stroke="#032B49"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);
